// Taşeron portalı — taşeron-kapsamlı belge FORM GÖVDESİ (tür + geçerlilik + not).
//
// S19-D7: bu dosyanın kendi `<Modal>`'ı (`DocumentUploadModal` — dosya seçici + tekil §8
// yükleme + §13.6 link mutasyonu) KALDIRILDI. Belge yükleme artık YALNIZ `UploadModal.tsx`
// üzerinden başlar (çoklu dosya/kalem orkestrasyonu: N alan grubu, yükle-sonra-link sırası,
// `resolveUpload`) ve `DocumentsPage.tsx` tek giriş noktası olarak onu çağırır.
//
// Geriye kalan — ve HÂLÂ CANLI olan — kısım, iki tüketicinin ödünç aldığı alan grubudur:
// `ContractorDocumentFieldGroup` → `UploadModal.tsx` (elle giriş dalı) ve `StrandedLinkModal.tsx`
// (analizi tamamlanamamış dosyayı elle bağlama).
//
// GL #7: tür listesi §27 kaydının `company` türleridir (sabit liste YOK); bitiş tarihi türün
// `expiryRule`'una göre görünür/zorunlu/gizlidir (`components/documents/DocumentTypeFields.tsx`).
// Kaydın yükleniyor/hata/boş durumu grupta DEĞİL, çağıranın grupların üstündeki TEK
// `DocumentTypesStatus`'undadır.

import { Field, Input, useDocumentTypes, withDocumentType } from '@isgportal/shared';
import type { Ref } from 'react';
import { useTranslation } from 'react-i18next';
import {
  type DocumentFieldsValue,
  DocumentTypeSelect,
  ValidUntilInput,
  useExpiryRule,
} from './documents/DocumentTypeFields';

/**
 * Taşeron-kapsamlı alan grubu (tür + iki tarih + not) — kontrollü, RHF'siz (çağıran,
 * `UploadModal.tsx`, N grubu TEK durumda tutar; her grup kendi RHF örneğini taşımaz).
 */
export function ContractorDocumentFieldGroup({
  idPrefix,
  value,
  onChange,
  disabled,
  typeError,
  typeSelectRef,
}: {
  idPrefix: string;
  value: DocumentFieldsValue;
  onChange: (next: DocumentFieldsValue) => void;
  disabled?: boolean;
  /** Sunucu bu grubun türünü reddetti (`INVALID`/`INACTIVE`) — hata seçicinin altında. */
  typeError?: string;
  /** Ret sonrası odak bu seçiciye taşınır. */
  typeSelectRef?: Ref<HTMLSelectElement>;
}) {
  const { t } = useTranslation();
  const { types } = useDocumentTypes();
  const rule = useExpiryRule('company', value.type);
  return (
    <div className="flex flex-col gap-4">
      <DocumentTypeSelect
        id={`${idPrefix}-type`}
        label={t('documents.field.type')}
        entity="company"
        value={value.type}
        disabled={disabled}
        error={typeError}
        selectRef={typeSelectRef}
        onChange={(code) => onChange(withDocumentType(types, 'company', value, code))}
      />
      <div className="grid gap-4 sm:grid-cols-2">
        <Field htmlFor={`${idPrefix}-valid-from`} label={t('documents.field.validFrom')}>
          <Input
            id={`${idPrefix}-valid-from`}
            type="date"
            value={value.validFrom}
            disabled={disabled}
            onChange={(e) => onChange({ ...value, validFrom: e.target.value })}
          />
        </Field>
        <ValidUntilInput
          id={`${idPrefix}-valid-until`}
          label={t('documents.field.validUntil')}
          rule={rule}
          value={value.validUntil}
          disabled={disabled}
          onChange={(validUntil) => onChange({ ...value, validUntil })}
        />
      </div>
      <Field htmlFor={`${idPrefix}-note`} label={t('documents.field.note')}>
        <Input
          id={`${idPrefix}-note`}
          value={value.note}
          disabled={disabled}
          onChange={(e) => onChange({ ...value, note: e.target.value })}
        />
      </Field>
    </div>
  );
}
